import {gql, useLazyQuery} from "@apollo/client";

const GET_STANDING = gql`
    query Standings($seasonId: Int!){
        standings(seasonId: $seasonId){
            groupId
            groupName
            stageName
            standings{
                id
                team{
                    id
                    name
                }
                stage{
                    id
                    name
                }
                played
                win
                otWin
                draw
                lose
                otLose
                scoreFor
                scoreAgainst
                scoreDifference
                points
            }

        }
    }
`;

export default function GetStanding() {
    return useLazyQuery(GET_STANDING);
};
